import React, { useState } from 'react';

const UserSearchModal = ({ isOpen, onClose, onSelectUser }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsLoading(true);
    try {
      await onSelectUser(email.trim());
      setEmail('');
      onClose();
    } catch (error) {
      console.error('Error sharing with user:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  };

  const modalContentStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '24px',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
    position: 'relative'
  };

  const titleStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#333333',
    textAlign: 'center'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    fontSize: '1rem',
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    marginBottom: '16px',
    boxSizing: 'border-box'
  };

  const buttonStyle = {
    width: '100%',
    padding: '12px',
    fontSize: '1rem',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginBottom: '8px',
    transition: 'all 0.2s ease'
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#007bff',
    color: '#ffffff'
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#f8f9fa',
    color: '#6c757d',
    border: '1px solid #e9ecef'
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '1.5rem',
    color: '#6c757d',
    cursor: 'pointer',
    padding: '4px',
    lineHeight: 1
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <button
          style={closeButtonStyle}
          onClick={onClose}
          title="Close"
        >
          ×
        </button>
        
        <h3 style={titleStyle}>Share with User</h3>
        
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            style={inputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter user's email address"
            required
            disabled={isLoading}
            autoFocus
          />
          
          <button
            type="submit"
            style={primaryButtonStyle}
            disabled={isLoading || !email.trim()}
            onMouseOver={(e) => {
              if (!isLoading && email.trim()) {
                e.target.style.backgroundColor = '#0056b3';
              }
            }}
            onMouseOut={(e) => {
              if (!isLoading) {
                e.target.style.backgroundColor = '#007bff';
              }
            }}
          >
            {isLoading ? 'Sharing...' : 'Share Event'}
          </button>
          
          <button
            type="button"
            style={secondaryButtonStyle}
            onClick={onClose}
            disabled={isLoading}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#e9ecef';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#f8f9fa';
            }}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserSearchModal;